import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { useHistory } from "react-router-dom";
import cursosimg from "../../static/images/cursos_default.png";
import { Modal } from "bootstrap";
import LinkButton from "../../utils/LinkButton";

const Formaciones = ({ id }) => {
  const [flag, setflag] = useState(false);
  const [Courses, setCourses] = useState([]);

  const history = useHistory();
  let userId = localStorage.getItem("userId");

  useEffect(() => {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    Carouselinner();
  }, [flag]);

  const Carouselinner = () => {
    axios.get("company-course/list-courses/" + id).then((result) => {
      setCourses(result.data);
    });
  };

  const h = {
    textAlign: "center",
  };

  const EditarVacante = (id) => {
    history.push({
      pathname: "/company/Vacante/Publica",
      state: {
        vacantId: id,
      },
    });
  };

  const btnEditar = {
    background: "#7821A0 0% 0% no-repeat padding-box",
    borderRadius: "32px",
    opacity: "1",
    textAlign: "center",
    letterSpacing: "0px",
    color: "#FFFFFF",
    width: "133px",
    height: "38px",
    verticalAlign: "middle",
    display: "table-cell",
    cursor: "pointer",
  };

  const btnCancelar = {
    background: "#F1F1F1 0% 0% no-repeat padding-box",
    borderRadius: "32px",
    opacity: 1,
    textAlign: "center",
    letterSpacing: "0px",
    color: "#7821A0",
    height: "38px",
    width: "173px",
  };

  return (
    <div className="vacancy__description bordered-box vacantes perfil-empresa usuario">
      <div className="bordered-box__header">
        <div className="bordered-box__header-title">Cursos</div>
      </div>
      <div className="recomendaciones">
        {Courses.map((item, index) => (
          <div key={index} className="box" style={{ maxHeight: "421px" }}>
            <div className="one-half" style={{ maxHeight: "421px" }}>
              <div className="head">
                <div className="company__wrapper">
                  <div className="logo">
                    <img
                      src={
                        item.fotoCurso != null
                          ? item.fotoCurso
                          : cursosimg
                      }
                      style={{ maxHeight: "138px", maxWidth: "130px" }}
                    ></img>
                  </div>

                  <div className="content">
                    <div className="cargo">{item.name}</div>
                    <div className="lugar">{item.ubicacion}</div>
                    {/* <div className="cuidad">
                      {item.companyDTOResponse.ubicacion}
                    </div> */}
                  </div>

                  {localStorage.getItem("rol") === "applicant" && (
                    <div className="aplicar mb-4">
                <LinkButton
                    to={`/user/DetalleCurso/${item.courseId}`}
                    className="btn-deg"
                  >
                    Ver
                  </LinkButton>
                    </div>
                  )}
                </div>
              </div>
              <div className="body mb-0 mt-0">
                <div className="left-side">
                  <ul>
                    <li>Publicado: {item.publicadoPor}</li>
                    {/* <li>Tipo: {item.companyDTOResponse.tipoEmpleo}</li>
                    <li>Experiencia: {item.companyDTOResponse.tipoEmpleo}</li> */}
                  </ul>
                </div>
                <div className="right-side">
                  <ul>
                    <li>
                      <i className="fa fa-eye" aria-hidden="true"></i>{" "}
                      Visualizaciones: {item.visualizaciones}
                      <a href="#">
                        <i className="fa fa-share-alt" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <i className="fa fa-folder-open" aria-hidden="true"></i>{" "}
                      {/* Aplicando: {item.companyDTOResponse.cantidadAplicantes} */}
                      <a href="#">
                        <i className="fa fa-bookmark" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <div className="footer mb-0 mt-0">
                 <div className="actitudes">
                  <div className="left-content">
                    Aptitudes:{" "}
                    {item.listSkillVacante
                      ?.map(function (lstSkills) {
                        return lstSkills.habilidad;
                      })
                      .join(" - ")}
                  </div>
                  <div className="right-content">
                    <a>
                      Salario:{" "}
                      {item.companyDTOResponse.tipoMoneda +
                        " " +
                        item.companyDTOResponse.salario}
                    </a>
                  </div>
                </div>  <div className="bottom-content">
                  <ul>
                    <li>
                      <a
                        href="#"
                        style={btnCancelar}
                        data-bs-toggle="modal"
                        data-bs-target="#cerrar-vacante-modal"
                        onClick={() =>
                          setcloseVacantId(
                            item.companyDTOResponse.companyVacantId
                          )
                        }
                      >
                        Cancelar
                      </a>
                    </li>
                    <li
                      onClick={() =>
                        EditarVacante(item.companyDTOResponse.companyVacantId)
                      }
                    >
                      <a style={btnEditar}>Editar</a>
                    </li>
                  </ul>
                </div> 
              </div>*/}
            </div>
          </div>
        ))}
      </div>

      <div
        id="kr-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={h}>
              <h3 htmlFor="cargo">
                Tu aplicación ha sido enviada exitosamente
              </h3>
            </div>
            {/* <div className="modal-footer">
              <button
                type="button"
                data-bs-dismiss="modal"
                //onClick={aplicarVacante}
                className="btn btn--small btn--purple"
                disabled={sending}
              >
                Agregar
              </button>
            </div>*/}
          </div>
        </div>
      </div>

      <div
        id="cerrar-vacante-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-sm" role="document">
          <div id="jobs" className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <div
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </div>
            </div>

            <div className="modal-body">
              <div className="form form--white">
                <div className="div__wrapper">
                  <div className="form__title text-center">
                    ¿Estas seguro que deseas cerrar la Vacante?
                  </div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        {" "}
                        Nota:Al cerrar la vacante,ya no podras recibir mas
                        pustulaciones de esta Vacante
                      </label>
                    </div>
                  </div>
                  <div
                    className="form__row mt-5"
                    id="buttons"
                    style={{ textAlign: "center" }}
                  >
                    <div
                      data-dismiss="modal"
                      className="btn btn-light"
                      style={{ borderRadius: "30px", padding: "15px" }}
                    >
                      {" "}
                      Cancelar
                    </div>
                    <div
                      className="btn btn-info"
                      style={{ padding: "14px" }}
                      // onClick={() => CerrarVacante()}
                    >
                      Cerrar Vacante
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Formaciones;
